import React from "react";

export function YaprioLogo({ size = 34, withText = true, subtitle = true }) {
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="nav-logo-yaprio">
      <img
        src="/yaprio-mark.svg"
        alt=""
        width={size}
        height={size}
        className="shrink-0 rounded-[30%]"
        draggable="false"
        aria-hidden="true"
      />
      {withText && (
        <div className="leading-none">
          <span className="font-heading text-xl font-extrabold tracking-tight text-slate-900">
            Yaprio
          </span>
          {subtitle && (
            <span className="block text-[10px] font-medium tracking-wide text-slate-400">
              meet. chat. be real.
            </span>
          )}
        </div>
      )}
    </div>
  );
}
